<template>
  <div>
    <div>
      <el-alert
          center
          v-if="type=='anonymous'"
          title="匿名话题只能由此进入进行修改或删除"
          type="success"
          :closable="false"
      >
      </el-alert>
      <br/>
    </div>
    <TopicCard :key="this.id" :type="type"></TopicCard>
  </div>
</template>

<script>
import TopicCard from "../components/TopicCardComponent.vue";
import {mapMutations} from "vuex";

export default {
  props: {
    id: {
      required: true
    },
    type: {
      type: String,
      default: "published"
    },
    published: {
      type: Boolean,
      required: false,
      default: true
    }
  }, //user id
  components: {
    TopicCard
  },
  methods: {
    ...mapMutations(["setUrls", "changeCurrentCategory"]),
    updateCategory: function () {
      this.changeCurrentCategory("");
      var topicsUrl = "";
      if (this.id !== undefined) {
        topicsUrl = "/users/" + this.id + "/topics";
      }
      switch (this.type) {
        case "anonymous":
          topicsUrl = "/user/topics/anonymous";
          break;
        case "unpublished":
          topicsUrl = "/user/topics/unpublished";
          break;
        case "closed":
          topicsUrl = "/users/" + this.id + "/topics/closed";
          break;
      }
      this.setUrls({
        topicsUrl: topicsUrl,
        tagsUrl: "/" + this.id + "/tags"
      });
    }
  },
  // when the view is first called and mounted.
  beforeMount() {
    this.updateCategory();
  },
  // when id is changed by the router
  beforeUpdate() {
    this.updateCategory();
  }
};
</script>
